enum TableTypeConstants {
  TABLE = 'TABLE',
  COMMUNAL_TABLE = 'COMMUNAL_TABLE',
}

export default TableTypeConstants;
